export const BASE_CLASS_NAME = 'select' as const;

export const SUGGESTION_FIELD_ICON_RESERVE_RIGHT = '1.5rem';
